import NavigationCard, { BaseImage } from '../../../navigation/NavigationCard';
import { InternalNavigation } from '../../../navigation/helper';
import React from 'react';
import { CAN_READ_CUSTOM_LIST, CAN_READ_ENTITY_GROUP, CAN_READ_QUERY_TEMPLATE } from '../../../auth/permissions';
import Has from '../../../auth/Has';
import { faCirclesOverlap, faFiles, faListUl } from '@fortawesome/pro-duotone-svg-icons';

export const CustomListsNavigationCard = () => {
  return (
    <Has allPermissions={CAN_READ_CUSTOM_LIST}>
      <NavigationCard
        title={'Custom Lists'}
        description={
          'Define and maintain Custom Lists, managing their records to form comprehensive data sets to be used across all products.'
        }
        to={InternalNavigation.customLists}
        image={{
          base: BaseImage.base2,
          icon: faListUl,
        }}
      />
    </Has>
  );
};

export const SegmentsNavigationCard = () => {
  return (
    <Has allPermissions={CAN_READ_ENTITY_GROUP}>
      <NavigationCard
        title={'Segments'}
        description={
          'Create and manage Person and Transaction Segments to support Screening and Monitoring configurations.'
        }
        to={InternalNavigation.segments}
        image={{
          base: BaseImage.base2,
          icon: faCirclesOverlap,
        }}
      />
    </Has>
  );
};
export const QueryTemplatesNavigationCard = ({ base }: { base: string }) => {
  return (
    <Has allPermissions={CAN_READ_QUERY_TEMPLATE}>
      <NavigationCard
        title={'Query Templates'}
        description={
          'Create and edit Query Templates to provide simple reusable data sets for configurations across all products.'
        }
        to={InternalNavigation.queryTemplates}
        image={{
          base,
          icon: faFiles,
        }}
      />
    </Has>
  );
};
